export default __webpack_public_path__ + "static/media/v-card.19b07670.png";